export const PaymentGatewayCode = {
    /** 간편카드결제 */
    EASY_CARD: '61',
    /** 간편계좌결제 */
    EASY_ACCOUNT: '62',
    /** 휴대폰 */
    MOBILE: '05',
    /** 네이버페이포인트(적립/충전) */
    PAY_POINT: '80',
} as const

export type PaymentGatewayCodeType = Constant<typeof PaymentGatewayCode>

/** 선택된 결제수단 키 */
export const BillingPayMethodsKey = {
    BANK_EASY_PAY: 'bankEasyPay',
    CARD_EASY_PAY: 'cardEasyPay',
    MOBILE: 'mobile',
    RECHARGE_POINT: 'recharge',
} as const

export type BillingPayMethodsKeyType = Constant<typeof BillingPayMethodsKey>

export const isBillingPayMethods = (key: string): key is keyof typeof BillingPayMethodsKey => {
    return key in BillingPayMethodsKey
}

/** 휴대폰 일반결제 PG  */
export const MobilePGChannel = {
    /** 다날 */
    DANAL: 'danal',
    /** 모빌리언스 */
    MOBILIANS: 'mobilians',
} as const

export type MobilePGChannelType = Constant<typeof MobilePGChannel>

export const PAYMENT_METHOD_CHANGE_POST_MESSAGE_KEY = 'paymentMethodChangePostMessageKey'
